module.exports = __webpack_public_path__ + "img/104.русский.ffece227.svg";